import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";

import { useWidgetsGate } from "#app/widgets/dashboards/widgets-gate";

/**
 * `/team/$teamId` — redirect to the team's landing tab: Overview when WIDGETS
 * is on (the tab only exists then), Board otherwise. Flags resolve async, so
 * hold on a spinner until `ready` — deciding early would send flag-on users
 * to the board on a fresh load.
 */
function TeamIndex() {
  const { workspace, teamId } = Route.useParams();
  const { ready, enabled: widgetsEnabled } = useWidgetsGate();

  if (!ready) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  const landingTab = widgetsEnabled ? "overview" : "board";
  return (
    <Navigate
      to={`/${workspace}/team/${teamId}/${landingTab}` as unknown as "/"}
      replace
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/")({
  component: TeamIndex,
});
